var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-modal",
    {
      attrs: { minimized: "", "no-backdrop-dismiss": "", "no-esc-dismiss": "" },
      model: {
        value: _vm.show_report,
        callback: function($$v) {
          _vm.show_report = $$v
        },
        expression: "show_report"
      }
    },
    [
      _c(
        "q-modal-layout",
        [
          _c(
            "q-toolbar",
            { attrs: { slot: "header" }, slot: "header" },
            [
              _c("q-btn", {
                attrs: { flat: "", round: "", dense: "", icon: "fas fa-times" },
                on: {
                  click: function($event) {
                    _vm.show_report = false
                  }
                }
              }),
              _c("q-toolbar-title", [
                _vm._v(
                  " " +
                    _vm._s(_vm.trail_id) +
                    " - " +
                    _vm._s(_vm.trail_title) +
                    " "
                )
              ])
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "layout-padding" },
            [
              _c("q-table", {
                ref: "table",
                staticClass: "q-mt-lg",
                attrs: {
                  data: _vm.data,
                  columns: _vm.columns,
                  "row-key": "id",
                  pagination: _vm.server_pagination,
                  loading: _vm.loading,
                  "no-data-label": _vm.$t("no_data_avaliable"),
                  "no-results-label": _vm.$t("no_results_found"),
                  "loading-label": _vm.$t("loading_data"),
                  "rows-per-page-label": _vm.$t("items_per_page"),
                  "rows-per-page-options": [5, 10, 50, 100],
                  "binary-state-sort": ""
                },
                on: {
                  "update:pagination": function($event) {
                    _vm.server_pagination = $event
                  },
                  request: _vm.request
                },
                scopedSlots: _vm._u([
                  {
                    key: "header",
                    fn: function(props) {
                      return _c(
                        "q-tr",
                        { attrs: { props: props } },
                        _vm._l(props.cols, function(col) {
                          return _c(
                            "q-th",
                            { key: col.name, attrs: { props: props } },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(_vm.$t(col.label)) +
                                  "\n                        "
                              )
                            ]
                          )
                        }),
                        1
                      )
                    }
                  },
                  {
                    key: "body",
                    fn: function(props) {
                      return [
                        _c(
                          "q-tr",
                          { attrs: { props: props } },
                          [
                            _c(
                              "q-td",
                              { key: "trail_title", attrs: { props: props } },
                              [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(props.row.trail_title) +
                                    "\n                            "
                                )
                              ]
                            ),
                            _c(
                              "q-td",
                              {
                                key: "trail_content_title",
                                attrs: { props: props }
                              },
                              [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(props.row.trail_content_title) +
                                    "\n                            "
                                )
                              ]
                            ),
                            _c(
                              "q-td",
                              {
                                key: "trail_content_type",
                                attrs: { props: props }
                              },
                              [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(
                                      _vm.$t(props.row.trail_content_type)
                                    ) +
                                    "\n                            "
                                )
                              ]
                            ),
                            _c(
                              "q-td",
                              {
                                key: "trail_content_result",
                                attrs: { props: props, "auto-width": "" }
                              },
                              [
                                _c(
                                  "q-chip",
                                  {
                                    staticClass: "full-width",
                                    attrs: {
                                      small: "",
                                      color: _vm.getColorResult(
                                        props.row.trail_content_result
                                      )
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(
                                          _vm.$t(
                                            _vm.getResult(
                                              props.row.trail_content_result
                                            )
                                          )
                                        ) +
                                        "\n                                "
                                    )
                                  ]
                                )
                              ],
                              1
                            ),
                            _c(
                              "q-td",
                              {
                                key: "trail_content_status",
                                attrs: { props: props, "auto-width": "" }
                              },
                              [
                                _c(
                                  "q-chip",
                                  {
                                    staticClass: "full-width",
                                    attrs: {
                                      small: "",
                                      color: _vm.getColorStatus(
                                        props.row.trail_content_type,
                                        props.row.trail_content_status
                                      )
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(
                                          _vm.$t(
                                            _vm.getStatus(
                                              props.row.trail_content_type,
                                              props.row.trail_content_status
                                            )
                                          )
                                        ) +
                                        "\n                                "
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }